//birds, general, flowers, insects, weather, colours, animals, countries, fish

const mix = [
  { kanji: "鷺", yomi: "さぎ" },
  { kanji: "鷹", yomi: "たか" },
  { kanji: "鶴", yomi: "つる" },
  { kanji: "燕", yomi: "つばめ" },
  { kanji: "鷂", yomi: "はいたか" },
  { kanji: "鳶", yomi: "とんび" },
  { kanji: "鷲", yomi: "わし" },
  { kanji: "烏", yomi: "からす" },
  { kanji: "鳳凰", yomi: "ほうおう" },
  { kanji: "鷦鷯", yomi: "みそさざい" },
  { kanji: "鶉", yomi: "うずら" },
  { kanji: "鶯", yomi: "うぐいす" },
  { kanji: "朱鷺", yomi: "とき" },
  { kanji: "鵲", yomi: "かささぎ" },
  { kanji: "梟", yomi: "ふくろう" },
  { kanji: "雉", yomi: "きじ" },
  { kanji: "鵜", yomi: "う" },
  { kanji: "鶚", yomi: "みさご" },
  { kanji: "翡翠", yomi: "かわせみ" },
  { kanji: "鴨", yomi: "かも" },
  { kanji: "孔雀", yomi: "くじゃく" },
  { kanji: "鵯", yomi: "ひよどり" },
  { kanji: "鸚鵡", yomi: "おうむ" },
  { kanji: "啄木鳥", yomi: "きつつき" },
  { kanji: "鸛", yomi: "こうのとり" },
  { kanji: "郭公", yomi: "かっこう" },
  { kanji: "雀", yomi: "すずめ" },
  { kanji: "駝鳥", yomi: "だちょう" },
  { kanji: "鶫", yomi: "つぐみ" },
  { kanji: "隼", yomi: "はやぶさ" },
  { kanji: "葦雀", yomi: "よしきり" },
  { kanji: "鶸", yomi: "ひわ" },
  { kanji: "雲雀", yomi: "ひばり" },
  { kanji: "欠伸", yomi: "あくび" },
  { kanji: "鼾", yomi: "いびき" },
  { kanji: "吃驚", yomi: "びっくり" },
  { kanji: "吃逆", yomi: "しゃっくり" },
  { kanji: "嚏", yomi: "くしゃみ" },
  { kanji: "憂鬱", yomi: "ゆううつ" },
  { kanji: "躊躇", yomi: "ちゅうちょ" },
  { kanji: "髑髏", yomi: "どくろ" },
  { kanji: "轆轤", yomi: "ろくろ" },
  { kanji: "朦朧", yomi: "もうろう" },
  { kanji: "齟齬", yomi: "そご" },
  { kanji: "算盤", yomi: "そろばん" },
  { kanji: "鍵盤", yomi: "けんばん" },
  { kanji: "纏足", yomi: "てんそく" },
  { kanji: "黶", yomi: "あざ" },
  { kanji: "顰蹙", yomi: "ひんしゅく" },
  { kanji: "玉響", yomi: "たまゆら" },
  { kanji: "薄荷", yomi: "はっか" },
  { kanji: "暖簾", yomi: "のれん" },
  { kanji: "胡椒", yomi: "こしょう" },
  { kanji: "櫛", yomi: "くし" },
  { kanji: "螺鈿", yomi: "らでん" },
  { kanji: "黴", yomi: "かび" },
  { kanji: "埃", yomi: "ほこり" },
  { kanji: "盥", yomi: "たらい" },
  { kanji: "仙人掌", yomi: "さぼてん" },
  { kanji: "囲炉裏", yomi: "いろり" },
  { kanji: "鼈", yomi: "すっぽん" },
  { kanji: "瑠璃", yomi: "るり" },
  { kanji: "黒子", yomi: "ほくろ" },
  { kanji: "皺", yomi: "しわ" },
  { kanji: "縞瑪瑙", yomi: "しまめのう" },
  { kanji: "藁", yomi: "わら" },
  { kanji: "羊羹", yomi: "ようかん" },
  { kanji: "煎餅", yomi: "せんべい" },
  { kanji: "鬘", yomi: "かつら" },
  { kanji: "瘡蓋", yomi: "かさぶた" },
  { kanji: "鉈", yomi: "なた" },
  { kanji: "鍬", yomi: "くわ" },
  { kanji: "箆", yomi: "へら" },
  { kanji: "放棄", yomi: "ほうき" },
  { kanji: "脛", yomi: "すね" },
  { kanji: "嘴", yomi: "くちばし" },
  { kanji: "蕨", yomi: "わらび" },
  { kanji: "鱶鰭", yomi: "ふかひれ" },
  { kanji: "雀斑", yomi: "そばかす" },
  { kanji: "脂", yomi: "やに" },
  { kanji: "塵", yomi: "ごみ" },
  { kanji: "錨", yomi: "いかり" },
  { kanji: "槌", yomi: "つち" },
  { kanji: "鑿", yomi: "のみ" },
  { kanji: "鋏", yomi: "はさみ" },
  { kanji: "梯", yomi: "はしご" },
  { kanji: "雪洞", yomi: "ぼんぼり" },
  { kanji: "洞穴", yomi: "どうけつ" },
  { kanji: "提灯", yomi: "ちょうちん" },
  { kanji: "生憎", yomi: "あいにく" },
  { kanji: "羹", yomi: "あつもの" },
  { kanji: "所謂", yomi: "いわゆる" },
  { kanji: "蠢", yomi: "うごめ(く)" },
  { kanji: "傀儡", yomi: "かいらい" },
  { kanji: "河童", yomi: "かっぱ" },
  { kanji: "逆鱗", yomi: "げきりん" },
  { kanji: "掏摸", yomi: "すり" },
  { kanji: "籠", yomi: "かご" },
  { kanji: "鉛筆", yomi: "えんぴつ" },
  { kanji: "貼付", yomi: "ちょうふ" },
  { kanji: "臍", yomi: "へそ" },
  { kanji: "比喩", yomi: "ひゆ" },
  { kanji: "頭垢", yomi: "ふけ" },
  { kanji: "率倒", yomi: "そっとう" },
  { kanji: "麓", yomi: "ふもと" },
  { kanji: "簪", yomi: "かんざし" },
  { kanji: "嶺", yomi: "れいれい" },
  { kanji: "襖", yomi: "ふすま" },
  { kanji: "鞦韆", yomi: "ぶらんこ" },
  { kanji: "護謨", yomi: "ごむ" },
  { kanji: "撥", yomi: "ばち" },
  { kanji: "薔薇", yomi: "ばら" },
  { kanji: "躑躅", yomi: "つつじ" },
  { kanji: "薊", yomi: "あざみ" },
  { kanji: "蒲公英", yomi: "たんぽぽ" },
  { kanji: "蘭", yomi: "らん" },
  { kanji: "菫", yomi: "すみれ" },
  { kanji: "鬱金香", yomi: "うっこんこう" },
  { kanji: "紫陽花", yomi: "あじさい" },
  { kanji: "菖蒲", yomi: "あやめ" },
  { kanji: "花梨", yomi: "かりん" },
  { kanji: "酸漿", yomi: "ほおずき" },
  { kanji: "百合", yomi: "ゆり" },
  { kanji: "秋桜", yomi: "こすもす" },
  { kanji: "桔梗", yomi: "ききょう" },
  { kanji: "百日紅", yomi: "さるすべり" },
  { kanji: "水芭蕉", yomi: "みずばしょう" },
  { kanji: "椿", yomi: "つばき" },
  { kanji: "萩", yomi: "はぎ" },
  { kanji: "向日葵", yomi: "ひまわり" },
  { kanji: "撫子", yomi: "なでしこ" },
  { kanji: "馬酔木", yomi: "あせび" },
  { kanji: "虎杖", yomi: "いたどり" },
  { kanji: "桐", yomi: "きり" },
  { kanji: "水仙", yomi: "すいせん" },
  { kanji: "石楠花", yomi: "しゃくなげ" },
  { kanji: "杜鵑花", yomi: "さつき" },
  { kanji: "敦盛草", yomi: "あつもりそう" },
  { kanji: "梓", yomi: "あずさ" },
  { kanji: "紫羅欄花", yomi: "あらせいとう" },
  { kanji: "槐", yomi: "えんじゅ" },
  { kanji: "朮", yomi: "おけら" },
  { kanji: "雛罌粟", yomi: "ひなげし" },
  { kanji: "彼岸花", yomi: "ひがんばな" },
  { kanji: "木槿", yomi: "むくげ" },
  { kanji: "燕子花", yomi: "かきつばた" },
  { kanji: "亜麻", yomi: "あま" },
  { kanji: "蜘蛛", yomi: "くも" },
  { kanji: "螻蛄", yomi: "けら" },
  { kanji: "蝶", yomi: "ちょう" },
  { kanji: "蛞蝓", yomi: "なめくじ" },
  { kanji: "蝸牛", yomi: "かたつむり" },
  { kanji: "蜈蚣", yomi: "むかで" },
  { kanji: "蜚蠊", yomi: "ごきぶり" },
  { kanji: "蛾", yomi: "が" },
  { kanji: "蚊", yomi: "か" },
  { kanji: "飛蝗", yomi: "ばった" },
  { kanji: "蜻蛉", yomi: "とんぼ" },
  { kanji: "蟷螂", yomi: "かまきり" },
  { kanji: "蜩", yomi: "ひぐらし" },
  { kanji: "蠶", yomi: "かいこ" },
  { kanji: "蛭", yomi: "ひる" },
  { kanji: "蟻", yomi: "あり" },
  { kanji: "蛍", yomi: "ほたる" },
  { kanji: "蝉", yomi: "せみ" },
  { kanji: "蚤", yomi: "のみ" },
  { kanji: "瓢虫", yomi: "てんとうむし" },
  { kanji: "蚯蚓", yomi: "みみず" },
  { kanji: "馬陸", yomi: "やすで" },
  { kanji: "蛆", yomi: "うじ" },
  { kanji: "蟋蟀", yomi: "こおろぎ" },
  { kanji: "螽斯", yomi: "きりぎりす" },
  { kanji: "蠍", yomi: "さそり" },
  { kanji: "霧", yomi: "きり" },
  { kanji: "霰", yomi: "あられ" },
  { kanji: "霙", yomi: "みぞれ" },
  { kanji: "霞", yomi: "かすみ" },
  { kanji: "露", yomi: "つゆ" },
  { kanji: "雹", yomi: "ひょう" },
  { kanji: "雫", yomi: "しずく" },
  { kanji: "靄", yomi: "もや" },
  { kanji: "霜", yomi: "しも" },
  { kanji: "暁", yomi: "あかつき" },
  { kanji: "黄昏", yomi: "たそがれ" },
  { kanji: "稲妻", yomi: "いなずま" },
  { kanji: "雷", yomi: "かみなり" },
  { kanji: "霹靂", yomi: "へきれき" },
  { kanji: "雲霞", yomi: "うんか" },
  { kanji: "五月雨", yomi: "さみだれ" },
  { kanji: "飃", yomi: "つむじかぜ" },
  { kanji: "凩", yomi: "こがらし" },
  { kanji: "旱", yomi: "ひでり" },
  { kanji: "颪", yomi: "おろし" },
  { kanji: "陽炎", yomi: "かげろう" },
  { kanji: "漣", yomi: "さざなみ" },
  { kanji: "凪", yomi: "なぎ" },
  { kanji: "薫風", yomi: "くんぷう" },
  { kanji: "朧月", yomi: "おぼろづき" },
  { kanji: "秋霖", yomi: "しゅうりん" },
  { kanji: "氷雨", yomi: "ひさめ" },
  { kanji: "時雨", yomi: "しぐれ" },
  { kanji: "時化", yomi: "しけ" },
  { kanji: "秋雨", yomi: "しゅうう" },
  { kanji: "東雲", yomi: "しののめ" },
  { kanji: "蜃気楼", yomi: "しんきろう" },
  { kanji: "樹氷", yomi: "じゅひょう" },
  { kanji: "氷柱", yomi: "つらら" },
  { kanji: "十六夜", yomi: "いざよい" },
  { kanji: "茜", yomi: "あかね" },
  { kanji: "蘇芳", yomi: "すおう" },
  { kanji: "臙脂", yomi: "えんじ" },
  { kanji: "朱華", yomi: "はねず" },
  { kanji: "杜若", yomi: "かきつばた" },
  { kanji: "褐色", yomi: "かっしょく" },
  { kanji: "銀", yomi: "ぎん" },
  { kanji: "橙色", yomi: "だいだいいろ" },
  { kanji: "芥子", yomi: "からし" },
  { kanji: "珊瑚", yomi: "さんご" },
  { kanji: "曙", yomi: "あけぼの" },
  { kanji: "淡香", yomi: "うすこう" },
  { kanji: "常盤色", yomi: "ときわいろ" },
  { kanji: "藍", yomi: "あい" },
  { kanji: "群青", yomi: "ぐんじょう" },
  { kanji: "縹", yomi: "はなだ" },
  { kanji: "納戸", yomi: "なんど" },
  { kanji: "琥珀", yomi: "こはく" },
  { kanji: "萌黄", yomi: "もえぎ" },
  { kanji: "海松色", yomi: "みるいろ" },
  { kanji: "紺鼠", yomi: "こんねず" },
  { kanji: "鈍色", yomi: "にびいろ" },
  { kanji: "灰汁色", yomi: "あくいろ" },
  { kanji: "承和色", yomi: "そがいろ" },
  { kanji: "退紅", yomi: "あらぞめ" },
  { kanji: "深緋", yomi: "こきあけ" },
  { kanji: "麒麟", yomi: "きりん" },
  { kanji: "鼬", yomi: "いたち" },
  { kanji: "駱駝", yomi: "らくだ" },
  { kanji: "鼠", yomi: "ねずみ" },
  { kanji: "栗鼠", yomi: "りす" },
  { kanji: "蜥蜴", yomi: "とかげ" },
  { kanji: "蝙蝠", yomi: "こうもり" },
  { kanji: "獅子女", yomi: "すふぃんくす" },
  { kanji: "馴鹿", yomi: "となかい" },
  { kanji: "犀", yomi: "さい" },
  { kanji: "兎", yomi: "うさぎ" },
  { kanji: "海驢", yomi: "あしか" },
  { kanji: "獺", yomi: "かわうそ" },
  { kanji: "氈鹿", yomi: "かもしか" },
  { kanji: "狐", yomi: "きつね" },
  { kanji: "山椒魚", yomi: "さんしょううお" },
  { kanji: "儒艮", yomi: "じゅごん" },
  { kanji: "獏", yomi: "ばく" },
  { kanji: "猿", yomi: "さる" },
  { kanji: "豹", yomi: "ひょう" },
  { kanji: "蝮", yomi: "まむし" },
  { kanji: "鼫鼠", yomi: "むささび" },
  { kanji: "土竜", yomi: "もぐら" },
  { kanji: "豪猪", yomi: "やまあらし" },
  { kanji: "冬眠鼠", yomi: "やまね" },
  { kanji: "驢馬", yomi: "ろば" },
  { kanji: "騾馬", yomi: "らば" },
  { kanji: "鰐", yomi: "わに" },
  { kanji: "獺虎", yomi: "らっこ" },
  { kanji: "蛙", yomi: "かえる" },
  { kanji: "貉", yomi: "むじな" },
  { kanji: "信天翁", yomi: "あほうどり" },
  { kanji: "亜米利加", yomi: "アメリカ" },
  { kanji: "英吉利", yomi: "イギリス" },
  { kanji: "伯剌西爾", yomi: "ブラジル" },
  { kanji: "埃及", yomi: "エジプト" },
  { kanji: "葡萄牙", yomi: "ポルトガル" },
  { kanji: "伊色剌", yomi: "イスラエル" },
  { kanji: "伊太利", yomi: "イタリア" },
  { kanji: "西班牙", yomi: "スペイン" },
  { kanji: "濠太剌利", yomi: "オーストラリア" },
  { kanji: "墺太利", yomi: "オーストリア" },
  { kanji: "阿蘭陀", yomi: "オランダ" },
  { kanji: "蘇格蘭", yomi: "スコットランド" },
  { kanji: "新西蘭", yomi: "ニュージーランド" },
  { kanji: "波蘭", yomi: "ポーランド" },
  { kanji: "義蘭", yomi: "イラン" },
  { kanji: "烏克蘭", yomi: "ウクライナ" },
  { kanji: "芬蘭", yomi: "フィンランド" },
  { kanji: "錫蘭", yomi: "スリランカ" },
  { kanji: "希臘", yomi: "ギリシャ" },
  { kanji: "土耳古", yomi: "トルコ" },
  { kanji: "諾威", yomi: "ノルウェー" },
  { kanji: "仏蘭西", yomi: "フランス" },
  { kanji: "盧森堡", yomi: "ルクセンブルク" },
  { kanji: "緬甸", yomi: "ミャンマー" },
  { kanji: "黎巴嫩", yomi: "レバノン" },
  { kanji: "鮫", yomi: "さめ" },
  { kanji: "海鷂魚", yomi: "えい" },
  { kanji: "鯨", yomi: "くじら" },
  { kanji: "烏賊", yomi: "いか" },
  { kanji: "蛸", yomi: "たこ" },
  { kanji: "鰰", yomi: "うたうた" },
  { kanji: "蜆", yomi: "しじみ" },
  { kanji: "鯱", yomi: "しゃちほこ" },
  { kanji: "海鰻", yomi: "あなご" },
  { kanji: "鰻", yomi: "うなぎ" },
  { kanji: "糠蝦", yomi: "あみ" },
  { kanji: "鮟鱇", yomi: "あんこう" },
  { kanji: "鰯", yomi: "いわし" },
  { kanji: "海老", yomi: "えび" },
  { kanji: "牡蠣", yomi: "かき" },
  { kanji: "鰹", yomi: "かつお" },
  { kanji: "蟹", yomi: "かに" },
  { kanji: "鼠頭魚", yomi: "きす" },
  { kanji: "細螺", yomi: "きさご" },
  { kanji: "海月", yomi: "くらげ" },
  { kanji: "鯉", yomi: "こい" },
  { kanji: "鮭", yomi: "さけ" },
  { kanji: "鮗", yomi: "このしろ" },
  { kanji: "鰆", yomi: "さわら" },
  { kanji: "柳葉魚", yomi: "ししゃも" },
  { kanji: "青竜蝦", yomi: "しゃこ" },
  { kanji: "鱸", yomi: "すずき" },
  { kanji: "大口魚", yomi: "たら" },
  { kanji: "鱘魚", yomi: "ちょうざめ" },
  { kanji: "鰌", yomi: "どじょう" },
  { kanji: "鯰", yomi: "なまず" },
  { kanji: "鯊", yomi: "はぜ" },
  { kanji: "鱧", yomi: "はも" },
  { kanji: "鰒", yomi: "ふぐ" },
  { kanji: "鱒", yomi: "ます" },
  { kanji: "鮪", yomi: "まぐろ" },
  { kanji: "鰡", yomi: "ぼら" },
];

export { mix };
